exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*初始化*/\r\nhtml, body, div{\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\nhtml{\r\n    font-size: 16px;\r\n}\r\n\r\nbody{\r\n    overflow: hidden;\r\n    position: absolute;\r\n}\r\n\r\nul{\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/global.css
// module id = 9
// module chunks = 0